<script>
    import { Circle } from "svelte-loading-spinners";
    export let loading = false;
  </script>
  
  {#if loading}
    <div class="modal-overlay">
      <div class="modal-container">
        <Circle size="50" unit="px" color="#474bff" />
      </div>
    </div>
  {/if}
  
  <style>
    .modal-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.1);
      z-index: 1010;
      display: flex;
    }
    .modal-container {
      margin: auto;
      /* 	background-color: #fff; */
      padding: 5px;
      border-radius: 50px;
      /*   box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23); */
    }
  </style>